export const CLEVERLINK_API_BASE_URL = '/api'
export const RESOURCES = {
  CONSULTANTS: 'consultants',
  EXPERIENCES: 'experiences',
  CERTIFICATIONS: 'certifications',
  LANGUAGE_LEVELS: 'languageLevels',
  SKILLS: 'skills',
  FILTERS_CONFIG: 'filters-config',
  PROFILES: 'profiles',
  USERS: 'users',
  INVITATIONS: 'invitations',
}

export const HTTP_GET_FILTERS = {
  OFFSET: 'offset',
  LIMIT: 'limit',
  QUERY: 'query',
  SORT: 'sort',
  SORT_BY: 'sortBy',
  SORT_ORDER: 'sortOrder',
  SEARCH: 'search',
}

export const HTTP_GET_FILTER_DEFAULT_VALUES = {
  [HTTP_GET_FILTERS.OFFSET]: 0,
  [HTTP_GET_FILTERS.LIMIT]: 10,
  [HTTP_GET_FILTERS.SORT_BY]: 'id',
  [HTTP_GET_FILTERS.SORT_ORDER]: 'asc',
}
